var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    {
      ref: "wrapper",
      staticClass: "player",
      class: { inactive: !_vm.activeInterface },
      on: { mousemove: _vm.mouseMove },
    },
    [
      _c(
        "div",
        {
          staticClass: "vid-container",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.pictureClick.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "video",
            {
              ref: "player",
              attrs: {
                width: "1680",
                height: "944",
                playsinline: "",
                autoplay: "",
              },
            },
            [_c("source", { attrs: { type: "video/mp4", src: _vm.videoURL } })]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "p-btn x",
          class: { inactive: !_vm.activeInterface },
          attrs: { to: "/preview" },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M19.4706 2.5L2.5 19.4706",
                  stroke: "white",
                  "stroke-width": "3",
                  "stroke-linecap": "square",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M19.4706 19.4706L2.5 2.5",
                  stroke: "white",
                  "stroke-width": "3",
                  "stroke-linecap": "square",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btm",
          class: { inactive: !_vm.activeInterface },
          on: { mouseenter: _vm.mouseIn, mouseleave: _vm.mouseOut },
        },
        [
          _c("div", { staticClass: "container n-mx" }, [
            _c("div", { staticClass: "timeline-info" }, [
              _c("div", { staticClass: "current" }, [
                _c("span", { staticClass: "ft-bld" }, [
                  _vm._v(_vm._s(_vm.currentTime || "00:00")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "timeline" },
                [
                  _c("slider", {
                    attrs: {
                      handles: [0],
                      connect: [true, false],
                      range: {
                        min: 0,
                        max: 1,
                      },
                      set: _vm.setValueTime,
                    },
                    on: {
                      start: _vm.sliderStartTime,
                      change: _vm.sliderChangeTime,
                      end: _vm.sliderEndTime,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "remaining" }, [
                _c("span", { staticClass: "ft-bld" }, [
                  _vm._v(_vm._s(_vm.totalTime || "00:00")),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "actns" }, [
              _c("div", { staticClass: "lft" }, [
                _c("div", { staticClass: "col txt-info" }, [
                  _c(
                    "span",
                    {
                      staticClass: "ft-xbld name",
                      style: { color: _vm.Global.mockupConfig.colors.icons },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.asset.name) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ctr" }, [
                _c(
                  "div",
                  {
                    staticClass: "fast bwd",
                    class: { mve: _vm.quickBw },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goBw.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 38 38",
                          fill: "none",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              d: "M19 6.00002C26.732 6.00002 33 12.268 33 20C33 27.732 26.732 34 19 34C11.268 34 5.00002 27.732 5.00002 20C5.00002 16.134 6.56702 12.634 9.10052 10.1005C9.42449 9.77656 9.76425 9.4684 10.1186 9.17729",
                              stroke: _vm.Global.mockupConfig.colors.icons,
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M21.25 1.69672L16.9467 6.00002L21.25 10.3033",
                              stroke: _vm.Global.mockupConfig.colors.icons,
                              "stroke-width": "3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M15.0423 24.75V18.432L13.5863 19.407L12.4943 17.704L15.4453 15.767H17.4343V24.75H15.0423ZM21.8656 24.984C20.713 24.984 19.855 24.5983 19.2916 23.827C18.737 23.047 18.4596 21.864 18.4596 20.278C18.4596 17.106 19.621 15.52 21.9436 15.52C23.0963 15.52 23.95 15.91 24.5046 16.69C25.068 17.4613 25.3496 18.64 25.3496 20.226C25.3496 23.398 24.1883 24.984 21.8656 24.984ZM21.9046 22.943C22.156 22.943 22.351 22.8607 22.4896 22.696C22.637 22.5313 22.7453 22.2583 22.8146 21.877C22.884 21.487 22.9186 20.9453 22.9186 20.252C22.9186 19.5933 22.8883 19.069 22.8276 18.679C22.767 18.289 22.663 18.0073 22.5156 17.834C22.3683 17.652 22.1646 17.561 21.9046 17.561C21.6533 17.561 21.454 17.6433 21.3066 17.808C21.168 17.9727 21.064 18.25 20.9946 18.64C20.9253 19.0213 20.8906 19.5587 20.8906 20.252C20.8906 20.9107 20.921 21.435 20.9816 21.825C21.0423 22.215 21.1463 22.501 21.2936 22.683C21.441 22.8563 21.6446 22.943 21.9046 22.943Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "play",
                    class: { paused: _vm.isPlaying },
                    style: { background: _vm.Global.mockupConfig.colors.icons },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.togglePlayState.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "a" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "21",
                            height: "26",
                            viewBox: "0 0 21 26",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M0 4.39878C0 1.6322 3.05843 -0.0407015 5.38799 1.45166L18.8143 10.0529C20.9637 11.4298 20.9637 14.5702 18.8143 15.9471L5.38799 24.5483C3.05843 26.0407 0 24.3678 0 21.6012V4.39878Z",
                              fill: "black",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "b" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "24",
                            viewBox: "0 0 20 24",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M5.88234 23.1765H1.17647C0.526723 23.1765 0 22.6497 0 22V2.00001C0 1.35027 0.526723 0.823545 1.17647 0.823545H5.88234C6.53209 0.823545 7.05881 1.35027 7.05881 2.00001V22C7.05881 22.6497 6.53209 23.1765 5.88234 23.1765Z",
                              fill: "black",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M18.8235 23.1765H14.1176C13.4679 23.1765 12.9412 22.6497 12.9412 22V2.00001C12.9412 1.35027 13.4679 0.823545 14.1176 0.823545H18.8235C19.4733 0.823545 20 1.35027 20 2.00001V22C20 22.6497 19.4733 23.1765 18.8235 23.1765Z",
                              fill: "black",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fast fwd",
                    class: { mve: _vm.quickFw },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goFw.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 38 38",
                          fill: "none",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              d: "M19 6.00002C11.268 6.00002 5 12.268 5 20C5 27.732 11.268 34 19 34C26.732 34 33 27.732 33 20C33 16.134 31.433 12.634 28.8995 10.1005C28.5755 9.77656 28.2358 9.4684 27.8814 9.17729",
                              stroke: _vm.Global.mockupConfig.colors.icons,
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16.75 1.69672L21.0533 6.00002L16.75 10.3033",
                              stroke: _vm.Global.mockupConfig.colors.icons,
                              "stroke-width": "3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M15.0423 24.75V18.432L13.5863 19.407L12.4943 17.704L15.4453 15.767H17.4343V24.75H15.0423ZM21.8656 24.984C20.713 24.984 19.855 24.5983 19.2916 23.827C18.737 23.047 18.4596 21.864 18.4596 20.278C18.4596 17.106 19.621 15.52 21.9436 15.52C23.0963 15.52 23.95 15.91 24.5046 16.69C25.068 17.4613 25.3496 18.64 25.3496 20.226C25.3496 23.398 24.1883 24.984 21.8656 24.984ZM21.9046 22.943C22.156 22.943 22.351 22.8607 22.4896 22.696C22.637 22.5313 22.7453 22.2583 22.8146 21.877C22.884 21.487 22.9186 20.9453 22.9186 20.252C22.9186 19.5933 22.8883 19.069 22.8276 18.679C22.767 18.289 22.663 18.0073 22.5156 17.834C22.3683 17.652 22.1646 17.561 21.9046 17.561C21.6533 17.561 21.454 17.6433 21.3066 17.808C21.168 17.9727 21.064 18.25 20.9946 18.64C20.9253 19.0213 20.8906 19.5587 20.8906 20.252C20.8906 20.9107 20.921 21.435 20.9816 21.825C21.0423 22.215 21.1463 22.501 21.2936 22.683C21.441 22.8563 21.6446 22.943 21.9046 22.943Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rgt" }, [
                _c(
                  "div",
                  {
                    staticClass: "vol-outer",
                    class: { active: _vm.activeVolBar },
                    on: { mouseleave: _vm.leaveVol },
                  },
                  [
                    _c("slider", {
                      attrs: {
                        handles: [1],
                        connect: [true, false],
                        range: {
                          min: 0,
                          max: 1,
                        },
                        set: _vm.setCurrentVol,
                      },
                      on: {
                        update: _vm.sliderChangeVol,
                        end: _vm.sliderEndVol,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "p-btn vol",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.toggleMute.apply(null, arguments)
                          },
                          mouseenter: _vm.enterVol,
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "35",
                              height: "23",
                              viewBox: "0 0 35 23",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M6.5 6.91867H3.33333C2.59733 6.91867 2 7.516 2 8.252V14.5853C2 15.3213 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4133C12.672 21.148 14 20.532 14 19.396V3.44133C14 2.30533 12.6707 1.68933 11.8053 2.424L6.5 6.91867Z",
                                fill: "white",
                                stroke: "white",
                                "stroke-width": "1",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              class: { hde: _vm.currentVol == 0 },
                              attrs: {
                                d: "M19.3827 16.7227C20.932 15.76 22 13.7573 22 11.4253C22 9.09333 20.932 7.08933 19.3827 6.11467",
                                stroke: "white",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              class: { hde: _vm.currentVol < 0.5 },
                              attrs: {
                                d: "M23.34 20.8387C25.7507 18.7653 27.3333 15.3253 27.3333 11.4227C27.3333 7.51467 25.748 4.072 23.3333 2",
                                stroke: "white",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              class: { shw: _vm.currentVol == 0 },
                              attrs: {
                                width: "3",
                                height: "15",
                                rx: "1.5",
                                transform:
                                  "matrix(0.707103 0.70711 -0.707103 0.70711 27.8491 5.24249)",
                                fill: "white",
                              },
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              class: { shw: _vm.currentVol == 0 },
                              attrs: {
                                width: "3",
                                height: "15",
                                rx: "1.5",
                                transform:
                                  "matrix(0.707107 -0.707107 0.707114 0.7071 17.2427 7.36389)",
                                fill: "white",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "p-btn fs",
                    class: { active: _vm.isFs },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.toggleFs.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "26px",
                          height: "26px",
                          viewBox: "0 0 26 26",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              stroke: "none",
                              "stroke-width": "1",
                              fill: "none",
                              "fill-rule": "evenodd",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  transform: "translate(2.000000, 2.000000)",
                                  stroke: "#FFFFFF",
                                  "stroke-width": "3",
                                },
                              },
                              [
                                _c("g", { staticClass: "g-arw top" }, [
                                  _c("polyline", {
                                    attrs: {
                                      transform:
                                        "translate(18.250000, 3.750000) rotate(-270.000000) translate(-18.250000, -3.750000) ",
                                      points:
                                        "14.5 7.5 14.5 -9.09494702e-13 22 -9.09494702e-13",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "21.5",
                                      y1: "0.5",
                                      x2: "13.5",
                                      y2: "8.5",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("g", { staticClass: "g-arw bot" }, [
                                  _c("line", {
                                    attrs: {
                                      x1: "8.5",
                                      y1: "13.5",
                                      x2: "0.5",
                                      y2: "21.5",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("polyline", {
                                    attrs: {
                                      transform:
                                        "translate(3.750000, 18.250000) rotate(-90.000000) translate(-3.750000, -18.250000) ",
                                      points:
                                        "-2.13162821e-13 22 0 14.5 7.5 14.5",
                                    },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "more" }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }